<template>
  <container :time='time' id='price' num='01' title='价格表'>
    <div :class='$style.tableHeader'>
      <div :class='$style.headerItem' :key='k' v-for='(v,k) in header'>{{v}}</div>
    </div>
    <div :class='$style.tableContent' :key='k' v-for='(v,k) in tableData'>
      <div :class='$style.tableItem' :key='k1' v-for='(v1,k1) in v'>{{v1}}</div>
    </div>
    <footer :class='$style.footer'>注：零售及团购均顺丰包邮，现货走顺丰空运包邮，包装盒免费OEM贴标，散装批发包装运费自理。</footer>
  </container>
</template>

<script>
import Container from "./Container";
export default {
  name: "Price",
  components: { Container },
  data() {
    return {
      header: [],
      tableData: [],
      time: ""
    };
  },
  mounted() {
    this.header = window.price.header.split(",");
    let tableData = window.price.data.map(v => {
      let data = v.split(",");
      this.tableData.push(data);
    });
    this.time = this.getUpdateTime();
  },
  methods: {
    getUpdateTime() {
      const hour = 60 * 60 * 1000;
      const eight = 8 * hour;
      const oneDay = 24 * hour;
      let localDay = new Date().toLocaleDateString();
      let today = +new Date(localDay) + eight;
      let now = +new Date();
      let yesterDay = now - oneDay;
      let test = new Date(yesterDay).toLocaleDateString();
      return now > today ? `${localDay} 08:00` : `${test} 08:00`;
    }
  }
};
</script>

<style lang='scss' module>
@import "../tool";
.tableHeader {
  border-bottom: 1px solid #000;
}
.tableHeader,
.tableContent {
  @extend .flex;
  padding: 10px 0;
}
.headerItem,
.tableItem {
  flex: 1;
  text-align: center;
}
.tableContent:nth-child(2n) {
  background-color: #fff;
}
.tableItem:nth-child(1) {
  padding-left: 10px;
}

.footer {
  margin-top: 18px;
  font-size: 12px;
  color: #333333;
}
</style>